import Main from "./pages/Main";
import Approved from "./pages/Approved";
import Pending from "./pages/Pending";

export default {
  Main,
  Approved,
  Pending
}